import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledSecondaryNavigationPlaceholder = styled.div`
  height: ${toRem(56)};
`;

export const StyledSecondaryNavigationContainer = styled.div<{
  isSticky: boolean;
  top: number;
  shouldAnimateTop: boolean;
  shouldAnimateBottom: boolean;
}>`
  position: ${({ isSticky }) => (isSticky ? 'fixed' : 'relative')};
  top: ${({ isSticky, top }) => (isSticky ? `${top}px` : 'auto')};
  left: ${({ isSticky }) => (isSticky ? '0' : 'auto')};
  width: ${({ isSticky }) => (isSticky ? '100%' : 'auto')};
  z-index: ${({ isSticky }) => (isSticky ? 29 : 'auto')};
  ${({ shouldAnimateTop }) => (shouldAnimateTop ? 'transition: top 0.4s ease;' : '')}
  ${({ shouldAnimateBottom }) => (shouldAnimateBottom ? 'animation: top 0.4s ease;' : '')}
`;
